<template>
    <div class="user-menu">
        <ul>
            <li @click="toggle">
                <edit-profile-button></edit-profile-button>
            </li>
            <li>
                <logout-button></logout-button>
            </li>
        </ul>
    </div>
</template>

<script>
    import EditProfileButton from "./EditProfileButton";
    import LogoutButton      from "./LogoutButton";
    import TweenMax          from "gsap";
    import ClickOffHandler   from "../../../../Lib/helpers/ClickOffHandler";

    export default {
        name      : "user-menu",
        components: {
            EditProfileButton,
            LogoutButton,
        },

        data() {
            return {
                userMenuActive: false
            }
        },

        watch: {
            userMenuActive() {
                this.animateUserMenu();
            },
        },

        methods: {
            toggle() {
                this.userMenuActive = !this.userMenuActive;
            },

            animateUserMenu() {
                this.userMenuActive ? this.animateShowUserMenu() : this.animateHideUserMenu();
            },

            animateShowUserMenu() {
                TweenMax.fromTo(".user-arrow", 0.25, {
                    rotation: 0,
                    ease    : Power4.ease,
                }, {
                    rotation: -90,
                });

                TweenMax.fromTo(".user-menu", 0.25, {
                    autoAlpha: 0,
                    right    : "-4rem",
                    ease     : Power4.ease,
                }, {
                    autoAlpha: 1,
                    right    : 0,
                });
            },

            animateHideUserMenu() {
                TweenMax.to(".user-arrow", 0.25, {
                    rotation: 0,
                    ease    : Power4.ease,
                });
                TweenMax.to(".user-menu", 0.25, {
                    autoAlpha: 0,
                    right    : "-4rem",
                    ease     : Power4.ease,
                });
            },


        },

        mounted() {
            new ClickOffHandler('.user-wrapper', () => {
                this.userMenuActive = false;
            }, '.user-menu');
        }
    }
</script>
